/* eslint-disable class-methods-use-this */

import {isNumber} from 'lodash';

import {makeEnumTypeGuard} from '../../../../../libs/shared/helpers/src/typescript/enumHelpers';
import {CustomFieldModel} from '../../../../models/api/customFieldModel';
import {SettingsCustomFieldsPagesEnum} from '../../../../models/url/settingsUrlModel';
import {AtomParams, AtomParamTypesEnum, ClientAtom, UninferredAtom} from '../expressionAtomModel';
import {buildParameter} from '../expressionParamHelpers';
import {ExpressionsContext} from '../expressionsContext';
import {InferredType, Method, MethodCategoriesEnum, ResultTypesEnum, UnknownResult} from './internal';

export class GetCustomField extends Method {
  constructor(private resource: SettingsCustomFieldsPagesEnum) {
    super(MethodCategoriesEnum.CUSTOM_FIELD);
  }

  inferType(atom: UninferredAtom, context: ExpressionsContext) {
    const customFields = context.customFields[this.resource];
    const customField = getCustomFieldFromAtomParams(atom.params, customFields || []);
    if (!customField) {
      return UnknownResult;
    }

    return inferCustomField(customField);
  }

  getDefaultName(atom: ClientAtom, context: ExpressionsContext) {
    const customFields = context.customFields[this.resource];
    const customField = getCustomFieldFromAtomParams(atom.params, customFields || []);
    if (!customField) {
      return undefined;
    }

    return customField.name;
  }

  getParameters() {
    return [buildParameter('custom_field', AtomParamTypesEnum.NUMBER, 'custom_field')];
  }
}

function inferCustomField(customField: CustomFieldModel): InferredType {
  return isExpressionType(customField.type) ? {type: customField.type} : UnknownResult;
}

const isExpressionType = makeEnumTypeGuard(ResultTypesEnum);

function getCustomFieldFromAtomParams(params: AtomParams, customFields: ReadonlyArray<CustomFieldModel>) {
  const customFieldId = params.custom_field;
  if (!isNumber(customFieldId)) {
    return undefined;
  }

  return customFields.find((field) => field.id === customFieldId) ?? undefined;
}
